/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Mobile_Paste_Text_Count_LimitInputs */

const en_mobile_paste_text_count_limit = /** @type {(inputs: Mobile_Paste_Text_Count_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} / ${i?.max} characters`)
};

const es_mobile_paste_text_count_limit = /** @type {(inputs: Mobile_Paste_Text_Count_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} / ${i?.max} caracteres`)
};

/**
* | output |
* | --- |
* | "{count} / {max} characters" |
*
* @param {Mobile_Paste_Text_Count_LimitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_paste_text_count_limit = /** @type {((inputs: Mobile_Paste_Text_Count_LimitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Paste_Text_Count_LimitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_paste_text_count_limit(inputs)
	return en_mobile_paste_text_count_limit(inputs)
});